import { Grid } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { WsTypography } from 'wisestep-base';

import { StandardHeightsByRows } from '../../../../../features/composableAnalytics';

import IApplicationInsights from './types/IApplicationInsights';

const ApplicationByCandidate = ({ agg }: { agg: IApplicationInsights }) => {
  const columns: GridColDef[] = [
    {
      field: 'id',
      hide: true,
    },
    {
      field: 'name',
      headerName: 'Candidate Name',
      flex: 1,
    },
    {
      field: 'source',
      headerName: 'Source',
      flex: 1,
    },
    {
      field: 'viewed',
      headerName: 'Viewed',
      flex: 1,
    },
    {
      field: 'acted',
      headerName: 'Acted',
      flex: 1,
    },
  ];

  return (
    <Grid item xs={12} height={StandardHeightsByRows[5]}>
      <WsTypography bold={true}>Applications By Candidates</WsTypography>
      <DataGrid
        columns={columns}
        rows={agg.data}
        pageSize={5}
        rowsPerPageOptions={[5]}
        sx={{ overflowY: 'hidden', mt: 2 }}
      />
    </Grid>
  );
};

export default ApplicationByCandidate;
